"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function getCaptionProps(a) {
  var b = a.filename,
      c = a.metaData;
  if (!c) return {
    title: b,
    fileExtension: ""
  };

  try {
    var d = JSON.parse("".concat(c)).type.split("/").pop();
    return {
      fileExtension: d,
      title: b.split(".".concat(d)).join("")
    };
  } catch (a) {
    return {
      title: b,
      fileExtension: ""
    };
  }
}

var _default = getCaptionProps;
exports["default"] = _default;